import Vue from "vue";
import VueRouter from "vue-router";
import loign from "../views/login.vue";
import enterpriseLogin from "../views/enterpriseLogin.vue";
import payLogin from "../views/payLogin.vue";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: loign,
  },

  {
    path: "/home",
    name: "home",
    redirect: "/project",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/home.vue"),
    children: [
      {
        // 项目管理
        path: "/project",
        name: "project",
        meta: {
          title: "/\xa0\xa0\xa0项目管理",
          superior: "/\xa0\xa0\xa0项目管理",
        },
        component: () => import("../views/system/project.vue"),
      },
      {
        // 企业管理
        path: "/enterprise",
        name: "enterprise",
        meta: {
          title: "/\xa0\xa0\xa0企业管理",
          superior: "/\xa0\xa0\xa0企业管理",
        },
        component: () => import("../views/system/enterprise.vue"),
      },
      {
        // 用户管理
        path: "/user",
        name: "user",
        meta: {
          title: "/\xa0\xa0\xa0用户管理",
          superior: "/\xa0\xa0\xa0用户管理",
        },
        component: () => import("../views/system/user.vue"),
      },
      {
        // 设备管理
        path: "/equipment",
        name: "equipment",
        meta: {
          title: "/\xa0\xa0\xa0设备管理",
          superior: "/\xa0\xa0\xa0设备管理",
        },
        component: () => import("../views/system/equipment.vue"),
      },
      {
        // 视频监控
        path: "/videoHtml",
        name: "videoHtml",
        meta: {
          title: "/\xa0\xa0\xa0视频监控",
          superior: "/\xa0\xa0\xa0视频监控",
        },
        component: () => import("../views/system/videoHtml.vue"),
      },
      {
        // 实时数据
        path: "/realTimeData",
        name: "realTimeData",
        meta: {
          title: "/\xa0\xa0\xa0实时数据",
          superior: "/\xa0\xa0\xa0实时数据",
        },
        component: () => import("../views/system/dataModule/realTimeData.vue"),
      },
      {
        // 历史数据
        path: "/historicalData",
        name: "historicalData",
        meta: {
          title: "/\xa0\xa0\xa0历史数据",
          superior: "/\xa0\xa0\xa0历史数据",
        },
        component: () =>
          import("../views/system/dataModule/historicalData.vue"),
      },
      {
        // 历史曲线
        path: "/historicalCurve",
        name: "historicalCurve",
        meta: {
          title: "/\xa0\xa0\xa0历史曲线",
          superior: "/\xa0\xa0\xa0历史曲线",
        },
        component: () =>
          import("../views/system/dataModule/historicalCurve.vue"),
      },
      {
        // 用量报表
        path: "/dosageStatement",
        name: "dosageStatement",
        meta: {
          title: "/\xa0\xa0\xa0用量报表",
          superior: "/\xa0\xa0\xa0用量报表",
        },
        component: () =>
          import("../views/system/dataModule/dosageStatement.vue"),
      },
      {
        // 统计报表
        path: "/statisticalForm",
        name: "statisticalForm",
        meta: {
          title: "/\xa0\xa0\xa0统计报表",
          superior: "/\xa0\xa0\xa0统计报表",
        },
        component: () =>
          import("../views/system/dataModule/statisticalForm.vue"),
      },
      {
        // 自由报表
        path: "/freedom",
        name: "freedom",
        meta: {
          title: "/\xa0\xa0\xa0统计报表",
          superior: "/\xa0\xa0\xa0统计报表",
        },
        component: () => import("../views/system/dataModule/freedom.vue"),
      },
      {
        // 组态界面
        path: "/ConfigurationInterface",
        name: "ConfigurationInterface",
        meta: {
          title: "/\xa0\xa0\xa0组态界面",
          superior: "/\xa0\xa0\xa0组态界面",
        },
        component: () => import("../views/system/ConfigurationInterface.vue"),
      },
      {
        // 员工账号
        path: "/staff",
        name: "staff",
        meta: {
          title: "/\xa0\xa0\xa0员工账号",
          superior: "/\xa0\xa0\xa0员工账号",
        },
        component: () => import("../views/system/staff.vue"),
      },
      {
        // 角色管理
        path: "/role",
        name: "role",
        meta: {
          title: "/\xa0\xa0\xa0角色管理",
          superior: "/\xa0\xa0\xa0角色管理",
        },
        component: () => import("../views/system/role.vue"),
      },
      {
        // 设备参数
        path: "/ListConfiguration",
        name: "ListConfiguration",
        meta: {
          title: "/\xa0\xa0\xa0设备参数",
          superior: "/\xa0\xa0\xa0设备参数",
        },
        component: () => import("../views/system/ListConfiguration.vue"),
      },
      {
        // 设备调试
        path: "/testEquipment",
        name: "testEquipment",
        meta: {
          title: "/\xa0\xa0\xa0设备调试",
          superior: "/\xa0\xa0\xa0设备调试",
        },
        component: () => import("../views/system/testEquipment.vue"),
      },
      {
        // 组态SVG
        path: "/editSVG",
        name: "editSVG",
        meta: {
          title: "/\xa0\xa0\xa0组态SVG",
          superior: "/\xa0\xa0\xa0组态SVG",
        },
        component: () => import("../views/system/components/editSVG.vue"),
      },
    ],
  },
  {
    path: "/enterpriseLogin",
    name: "enterpriseLogin",
    component: enterpriseLogin,
  },
  {
    path: "/enterpriseHome",
    name: "enterpriseHome",
    redirect: "/firmHome/realTimeData",
    component: () => import("../views/enterpriseHome.vue"),
    children: [
      {
        // 视频监控
        path: "/firmHome/videoHtml",
        name: "firmHomeVideoHtml",
        meta: {
          title: "/\xa0\xa0\xa0视频监控",
          superior: "/\xa0\xa0\xa0视频监控",
        },
        component: () => import("../views/system/firmHome/videoHtml.vue"),
      },
      {
        // 实时数据
        path: "/firmHome/realTimeData",
        name: "firmRealTimeData",
        meta: {
          title: "/\xa0\xa0\xa0实时数据",
          superior: "/\xa0\xa0\xa0实时数据",
        },
        component: () => import("../views/system/firmHome/realTimeData.vue"),
      },
      {
        // 历史数据
        path: "/firmHome/historicalData",
        name: "firmHistoricalData",
        meta: {
          title: "/\xa0\xa0\xa0历史数据",
          superior: "/\xa0\xa0\xa0历史数据",
        },
        component: () => import("../views/system/firmHome/historicalData.vue"),
      },
      {
        // 历史曲线
        path: "/firmHome/historicalCurve",
        name: "firmHistoricalCurve",
        meta: {
          title: "/\xa0\xa0\xa0历史曲线",
          superior: "/\xa0\xa0\xa0历史曲线",
        },
        component: () => import("../views/system/firmHome/historicalCurve.vue"),
      },
      {
        // 用量报表
        path: "/firmHome/dosageStatement",
        name: "firmDosageStatement",
        meta: {
          title: "/\xa0\xa0\xa0用量报表",
          superior: "/\xa0\xa0\xa0用量报表",
        },
        component: () => import("../views/system/firmHome/dosageStatement.vue"),
      },
      {
        // 统计报表
        path: "/firmHome/statisticalForm",
        name: "firmStatisticalForm",
        meta: {
          title: "/\xa0\xa0\xa0统计报表",
          superior: "/\xa0\xa0\xa0统计报表",
        },
        component: () => import("../views/system/firmHome/statisticalForm.vue"),
      },
      {
        // 自由报表
        path: "/firmHome/freedom",
        name: "firmHomeFreedom",
        meta: {
          title: "/\xa0\xa0\xa0统计报表",
          superior: "/\xa0\xa0\xa0统计报表",
        },
        component: () => import("../views/system/firmHome/freedom.vue"),
      },
      {
        // 组态界面
        path: "/firmHome/svgList",
        name: "svgList",
        meta: {
          title: "/\xa0\xa0\xa0组态界面",
          superior: "/\xa0\xa0\xa0组态界面",
        },
        component: () => import("../views/system/firmHome/svgList.vue"),
      },
      {
        // 组态SVG
        path: "/firmHome/editSVG",
        name: "firmHomeEditSVG",
        meta: {
          title: "/\xa0\xa0\xa0组态SVG",
          superior: "/\xa0\xa0\xa0组态SVG",
        },
        component: () => import("../views/system/components/editsvg1.vue"),
      },
      {
        // 操作员管理
        path: "/firmHome/operatorManagement",
        name: "operatorManagement",
        meta: {
          title: "/\xa0\xa0\xa0操作员管理",
          superior: "/\xa0\xa0\xa0操作员管理",
        },
        component: () =>
          import("../views/system/firmHome/operatorManagement.vue"),
      },
      {
        // 操作员管理
        path: "/firmHome/testEquipment",
        name: "firmTestEquipment",
        meta: {
          title: "/\xa0\xa0\xa0操作员管理",
          superior: "/\xa0\xa0\xa0操作员管理",
        },
        component: () => import("../views/system/testEquipment.vue"),
      },
    ],
  },
  {
    path: "/payLogin",
    name: "payLogin",
    component: payLogin,
  },
  {
    path: "/payHome",
    name: "payHome",
    redirect: "/pay/index",
    component: () => import("../views/payHome.vue"),
    children: [
      {
        // 充值中心
        path: "/pay/index",
        name: "payIndex",
        meta: {
          title: "/\xa0\xa0\xa0充值中心",
          superior: "/\xa0\xa0\xa0充值中心",
        },
        component: () => import("../views/system/pay/index.vue"),
      },
      {
        // 充值记录
        path: "/pay/payList",
        name: "payList",
        meta: {
          title: "/\xa0\xa0\xa0充值记录",
          superior: "/\xa0\xa0\xa0充值记录",
        },
        component: () => import("../views/system/pay/payList.vue"),
      },
      {
        // 余量调节
        path: "/pay/customer",
        name: "payCustomer",
        meta: {
          title: "/\xa0\xa0\xa0余量调节",
          superior: "/\xa0\xa0\xa0余量调节",
        },
        component: () => import("../views/system/pay/customer.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
